
import api from '@/store/api.js'
import aws from '@/store/aws.js'
import view from '@/store/view.js'

import createPersistedState from "vuex-persistedstate";
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    api,
    aws,
    view,
  },
  plugins: [createPersistedState({
    key: 'KuraemonCloud',
    paths: [
      'sample.email',
      'sample.obj',
    ],
    storage: window.sessionStorage
  })]
})
